import * as stickyfilljs from 'stickyfilljs';

import {
  Inject,
  Directive,
  AfterViewInit,
} from 'ng-metadata/core';

/**
 * Wrapper for position: sticky polyfill
 */
@Directive({
  selector: '[gw-sticky]',
})
export class StickyDirective implements AfterViewInit {

  constructor(
    @Inject('$element') private $element: ng.IRootElementService,
  ) {}

  ngAfterViewInit() {
    stickyfilljs.add(this.$element);
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/directives/sticky.directive.ts